import React, { useEffect } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import FormInput from '../../components/form/FormInput';
import { Controller, useFieldArray, useForm } from 'react-hook-form';
import { TextField } from '@mui/material';
import { getHeading } from '../../utils/helper';
import FormsetInput from '../../components/form/FormsetInput';
import { Button } from 'primereact/button';
import { ApiPost } from '../../helper/API/ApiData';
import { useNavigate, useParams } from 'react-router';
import { toast } from 'react-toastify';

const GroupMemberCreateTrainingForm = ({ trainings }: any) => {
    const { control, handleSubmit, formState: { errors }, setError } = useForm({
        defaultValues: {
            formSets: [{
                is_present: false,
                earnings: 0,
                hours_of_work_contributed: 0,
                reason_for_absence: "",
                role_in_enterprise: "",
                training: ""
            }], // initial values for form sets
        },
    });

    const { group_member_id } = useParams()
    const navigate = useNavigate()

    const { fields, append, remove, } = useFieldArray({
        control,
        name: 'formSets',
    });

    const onSubmit = (data: any) => {
        // Validate duplication of trainings
        const uniqueTrainings: { [key: string]: number } = {}
        const uniqueCheck = data.formSets.map((item: any, index: number) => {
            if (uniqueTrainings.hasOwnProperty(item.training)) {
                setError(`formSets.${uniqueTrainings[item.training]}.training`, {
                    type: "client",
                    message: "Training already used in the formset"
                })
                return "error"
            }
            else {
                uniqueTrainings[`${item.training}`] = index
            }
            return item.training
        })
        console.log("🚀 ~ onSubmit ~ uniqueCheck:", uniqueCheck)
        if (uniqueCheck.includes('error')){
            return
        }

        // Send formset to API
        console.log("🚀 ~ onSubmit ~ data:", data.formSets)
        ApiPost(`group_member/${group_member_id}/trainings/add`, data.formSets)
            .then((res: any) => {
                if (res.status === 200) {
                    toast.success("Successfully updated SHG Training")
                    navigate(`?page=training`)
                }
            }).catch((error) => {
                console.log("🚀 ~ .then ~ error:", error)
                if (error.status === 400 && error.code === 'validation_error') {
                    if (error.data.validation !== undefined) {
                        setError(error.data.validation.body.keys[0],
                            { type: "server", message: error.data.validation.body.message },
                            { shouldFocus: true })
                    }
                    if (error.data.data !== undefined) {
                        setError(`formSets.0.training`,
                            { type: "server", message: error.data.data.validation.body.message },
                            { shouldFocus: true })
                    }
                }
                return error
            })
    };

    return (

        <form onSubmit={handleSubmit(onSubmit)}>
            {fields.map((field, fieldIndex) => {
                return (
                    <div id={field.id} className='General_Info border-none'>
                        <Row className="flex justify-content-center align-items-center">
                            <Col xl={10} lg={10} md={10}>
                                <Row className="border p-2">
                                    <Col xl={4} lg={4} md={6} className="mt-3">
                                        <FormsetInput
                                            name={`formSets[${ fieldIndex }].training`}
                                            fieldOptions={{
                                                type: 'enum',
                                                validations: {
                                                    enum: trainings,
                                                    required: true
                                                }
                                            }}
                                            index={fieldIndex}
                                            control={control} errors={errors}
                                        />
                                    </Col>
                                    <Col xl={4} lg={4} md={6} className="mt-3">
                                        <FormsetInput
                                            name={`formSets[${ fieldIndex }].is_present`}
                                            fieldOptions={{
                                                type: 'boolean',
                                                validations: {
                                                    required: true
                                                }
                                            }}
                                            index={fieldIndex}
                                            control={control} errors={errors}
                                        />
                                    </Col>
                                    <Col xl={4} lg={4} md={6} className="mt-3">
                                        <FormsetInput
                                            name={`formSets[${ fieldIndex }].earnings`}
                                            fieldOptions={{
                                                type: 'int',
                                                validations: {
                                                    required: true
                                                }
                                            }}
                                            index={fieldIndex}
                                            control={control} errors={errors}
                                        />
                                    </Col>
                                    <Col xl={4} lg={4} md={6} className="mt-3">
                                        <FormsetInput
                                            name={`formSets[${ fieldIndex }].hours_of_work_contributed`}
                                            fieldOptions={{
                                                type: 'int',
                                                validations: {
                                                    required: true
                                                }
                                            }}
                                            index={fieldIndex}
                                            control={control} errors={errors}
                                        />
                                    </Col>
                                    <Col xl={4} lg={4} md={6} className="mt-3">
                                        <FormsetInput
                                            name={`formSets[${ fieldIndex }].reason_for_absence`}
                                            fieldOptions={{
                                                type: 'varchar',
                                                validations: {
                                                    required: true
                                                }
                                            }}
                                            index={fieldIndex}
                                            control={control} errors={errors}
                                        />
                                    </Col>
                                    <Col xl={4} lg={4} md={6} className="mt-3">
                                        <FormsetInput
                                            name={`formSets[${ fieldIndex }].role_in_enterprise`}
                                            fieldOptions={{
                                                type: 'varchar',
                                                validations: {
                                                    required: true
                                                }
                                            }}
                                            index={fieldIndex}
                                            control={control} errors={errors}
                                        />
                                    </Col>
                                </Row>
                            </Col>
                            <Col xl={2} lg={2} md={2} className='d-flex justify-content-center p-3'>
                                {fields.length > 1 &&
                                    <Button icon="pi pi-trash" outlined style={{ borderRadius: "50%", borderColor: "red", color: "red" }} onClick={() => remove(fieldIndex)} />
                                }
                            </Col>
                        </Row>
                    </div>
                )
            })}

            <div className='d-flex justify-content-between'>
                <Button icon="pi pi-plus" outlined style={{ borderRadius: "50%", }}
                    onClick={() => append({
                        is_present: false,
                        earnings: 0,
                        hours_of_work_contributed: 0,
                        reason_for_absence: "",
                        role_in_enterprise: "",
                        training: ""
                    })}
                />

                <Button icon="pi pi-check" />
            </div>
        </form >
    )
};

export default GroupMemberCreateTrainingForm;